<template>
  <div class="d-flex align-center">
    <div class="edit-day-picker-area" :class="{ full: !this.value }">
      <v-menu
        ref="targetDate"
        v-model="pickerFlag"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :label="label"
            readonly
            v-model="dateFormatted"
            v-on="on"
            :style="inputWidth"
            style="text-align: center; height: 100%"
            @blur="checkMonth"
          />
        </template>
        <v-date-picker
          v-model="date"
          locale="ja"
          no-title
          @input="
            pickerFlag = false;
            $emit('change', null);
          "
        ></v-date-picker>
      </v-menu>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: "対象年月日"
    },
    width: Number
  },

  data: vm => ({
    pickerFlag: false,
    formattingDate: vm.value
  }),

  watch: {
    value() {
      this.formattingDate = this.value;
    }
  },

  computed: {
    date: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.formattingDate = newValue;
        this.$emit("input", newValue);
      }
    },
    dateFormatted: {
      get() {
        if (!this.date) return null;
        const [year, month, day] = this.date.split("-");
        return `${year}年${month}月${day}日`;
      },
      set(newValue) {
        const regex = /^([0-9]+?)年([0-9]+?)月([0-9]+?)日$/g;
        const result = regex.exec(newValue);
        if (result) {
          const year = result[1];
          const month = result[2];
          const day = result[3];
          this.formattingDate =
            ("000" + year).slice(-4) +
            "-" +
            ("0" + month).slice(-2) +
            "-" +
            ("0" + day).slice(-2);
        }
      }
    },
    inputWidth() {
      if (this.width) {
        let inputW = this.width - 1;
        if (this.value) {
          inputW = this.width - 22 - 1;
        }
        return {
          width: inputW + "px;"
        };
      }
      return {};
    }
  },

  methods: {
    checkMonth() {
      this.$emit("input", this.formattingDate);
    },
    addDay(num) {
      const date = new Date(this.date.replace(/-/g, "/"));
      date.setTime(date.getTime() + 1000 * 60 * 60 * 9);
      date.setDate(date.getDate() + num);
      this.date = date.toISOString().substr(0, 10);
    }
  }
};
</script>

<style lang="scss">
.edit-day-picker-area {
  height: 100%;
  width: calc(100% - 22px);

  input {
    width: 100% !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  &.full {
    width: 100%;
  }
}
</style>
